import { render, staticRenderFns } from "./NostoapuvalineethuoltoView.vue?vue&type=template&id=724bccd5"
import script from "./NostoapuvalineethuoltoView.vue?vue&type=script&lang=js"
export * from "./NostoapuvalineethuoltoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports